import classnames from 'classnames';
import { FC } from 'react';
import { useMedia } from 'react-use';

import { Block, BlockHeader } from '../../../../../shared/lib/ui';
import S from './ContentTypes.module.scss';
import { useTranslation } from 'react-i18next';

export const ContentTypes: FC = () => {
  const { t, i18n } = useTranslation();
  const locale = i18n.resolvedLanguage;

  const isMobile = useMedia('only screen and (max-width: 743px)', false);

  return (
    <section>
      <BlockHeader
        block={t('webmaster.content_types_section.title')}
        title={t('webmaster.content_types_section.subtitle')}
      />
      <div className={S.Blocks}>
        {locale === 'ru' && (
          <Block
            title={
              <span className={S.Title}>
                {t('webmaster.content_types_section.card_1.title')}
              </span>
            }
            descr={
              <span className={S.Title}>
                {t('webmaster.content_types_section.card_1.description')}
              </span>
            }
            img="/assets/img/publishers/image-brands.png"
            color="blueViolet"
            action={t('webmaster.content_types_section.card_1.button')}
            href="/sign-up/webmaster"
            fullImg
            blockClass={S.FirstBlock}
            leftWrapClass={S.FirstBlockLeftWrap}
          />
        )}
        <div className={S.BlocksSmall}>
          <Block
            title={t('webmaster.content_types_section.card_2.title')}
            descr={t('webmaster.content_types_section.card_2.description')}
            img={`/assets/img/publishers/image-platforms-${locale || 'ru'}.png`}
            action={t('webmaster.content_types_section.card_2.button')}
            href="/call"
            size="small"
            color="white"
            imgClass={classnames(S.BlockSmallImg, S.SecondBlockImg)}
            leftWrapClass={S.BlockLeftWrap}
          />
          <Block
            title={t('webmaster.content_types_section.card_3.title')}
            descr={
              <span className={S.Title}>
                {t('webmaster.content_types_section.card_3.description')}
              </span>
            }
            img={`/assets/img/publishers/image-target-${locale || 'ru'}.png`}
            action={t('webmaster.content_types_section.card_3.button')}
            size="small"
            href="/message"
            color="black"
            fullImg={!isMobile}
            imagePadding
            noImageBottomPadding={isMobile}
            imgClass={classnames(S.BlockSmallImg, S.ThirdBlockImg)}
            leftWrapClass={S.BlockLeftWrap}
          />
        </div>
      </div>
    </section>
  );
};
